<template>
  <div>
    <base-nav
      v-model="showMenu"
      type="white"
      :transparent="true"
      menu-classes="justify-content-end"
      class="auth-navbar fixed-top"
    />

    <div class="wrapper wrapper-full-page">
      <div class="full-page center-items" :class="pageClass">
        <zoom-center-transition
          :duration="pageTransitionDuration"
          mode="out-in"
        >
          <router-view />
        </zoom-center-transition>
        <content-footer
          :footer-website="footerWebsite"
          :footer-company="footerCompany"
          :footer-year="footerYear"
        />
      </div>
    </div>
  </div>
</template>
<script>
import ContentFooter from "src/components/ContentFooter.vue";
import { BaseNav } from "src/components/UI";
import { ZoomCenterTransition } from "vue2-transitions";

export default {
  components: {
    BaseNav,
    ZoomCenterTransition,
    ContentFooter,
  },
  props: {
    backgroundColor: {
      type: String,
      default: "black",
    },
  },
  data() {
    return {
      showMenu: false,
      menuTransitionDuration: 250,
      pageTransitionDuration: 200,
      footerWebsite: "https://www.exnihilodev.com",
      footerCompany: "Ex Nihilo Studios",
      footerYear: new Date().getFullYear(),
      pageClass: "login-page",
    };
  },
  mounted() {
    this.setPageClass();
  },
  methods: {
    setPageClass() {
      this.pageClass = `${this.$route.name}-page`.toLowerCase();
    },
  },
};
</script>
<style lang="scss">
.navbar.auth-navbar {
  top: 0;
}

$scaleSize: 0.8;
@keyframes zoomIn8 {
  from {
    opacity: 0;
    transform: scale3d($scaleSize, $scaleSize, $scaleSize);
  }
  100% {
    opacity: 1;
  }
}

.wrapper-full-page .zoomIn {
  animation-name: zoomIn8;
}

@keyframes zoomOut8 {
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
    transform: scale3d($scaleSize, $scaleSize, $scaleSize);
  }
}

.wrapper-full-page .zoomOut {
  animation-name: zoomOut8;
}
.center-items {
  display: flex;
  align-items: center;
}
</style>
